import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/help.png'
import _imports_1 from '../assets/chat.png'


const _withScopeId = n => (_pushScopeId("data-v-8ff49894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "run-name" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { style: {"font-size":"75%"} }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { style: {"text-align":"left","padding-left":"20px"} }
const _hoisted_8 = { class: "option" }
const _hoisted_9 = { class: "option-description" }
const _hoisted_10 = { class: "option" }
const _hoisted_11 = { class: "option-description" }
const _hoisted_12 = { style: {"text-align":"left","padding-left":"20px"} }
const _hoisted_13 = { class: "option" }
const _hoisted_14 = { class: "option-description" }
const _hoisted_15 = { class: "option" }
const _hoisted_16 = {
  class: "basedialog",
  disabled: true
}
const _hoisted_17 = { class: "option-description" }
const _hoisted_18 = { class: "option" }
const _hoisted_19 = { class: "option-description" }
const _hoisted_20 = { style: {"padding":"10","text-align":"center"} }
const _hoisted_21 = { style: {"text-align":"center","padding":"30px"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { style: {"padding-left":"80px","text-align":"left","list-style":"none"} }
const _hoisted_25 = { style: {"padding":"15px"} }
const _hoisted_26 = {
  href: "https://daptadocs.com/Reference/The%20dashboard.html",
  target: "_blank"
}
const _hoisted_27 = { style: {"padding":"15px"} }
const _hoisted_28 = {
  href: "https://daptadocs.com/Tutorials/Simple%20component%20analysis.html",
  target: "_blank"
}
const _hoisted_29 = { style: {"padding":"15px"} }
const _hoisted_30 = {
  href: "https://daptadocs.com",
  target: "_blank"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"80px"},
  src: _imports_0,
  alt: "help"
}, null, -1))
const _hoisted_32 = { style: {"padding":"15px"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  onclick: "smartsupp('chat:open'); return false;"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"30px"},
    src: _imports_1,
    alt: "chat"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { id: "basedialogbuttons" }
const _hoisted_36 = { style: {"position":"absolute","bottom":"30px","right":"5%"} }
const _hoisted_37 = { style: {"text-align":"left","padding-left":"20px"} }
const _hoisted_38 = { style: {"list-style":"none","text-align":"left","padding":"0","margin":"0"} }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "secret-key" }
const _hoisted_41 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "secret-colon" }, [
  /*#__PURE__*/_createElementVNode("p", null, ":")
], -1))
const _hoisted_43 = { class: "secret-value" }
const _hoisted_44 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_45 = { class: "secret-key" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "secret-colon" }, [
  /*#__PURE__*/_createElementVNode("p", null, " : ")
], -1))
const _hoisted_48 = { class: "secret-value" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = { id: "basedialogbuttons" }
const _hoisted_51 = ["disabled"]

import _ from "lodash"
import {
  onUpdated,
  onMounted,
  onBeforeUnmount,
  ref,
  isRef,
  isReactive,
  computed,
  useSSRContext,
  watch,
  inject,
  toRaw
} from "vue";
import EditableNode from "./EditableNode.vue";
import ConnectionLine from "./EditableConnection.vue";
import BaseDialog from "./BaseDialog.vue";
import NodeForm from "./NodeForm.vue";
import ConnectionForm from "./ConnectionForm.vue";
import ContextMenu from "./ContextMenu.vue"
import {
  VueFlow,
  isEdge,
  removeElements,
  addEdge,
  MiniMap,
  Controls,
  Node,
  FlowElement,
  FlowInstance,
  Elements,
  Position,
  SnapGrid,
  FlowEvents,
  Connection,
  ConnectionMode,
  Edge,
  ArrowHeadType,
  Background,
} from "@braks/vue-flow";
import Shared from './shared.vue'
import userResourceQuotas from "./UserResourceQuotas.json"


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomEditableNode',
  props: {
  components: Array,
  connections: Array,
  workflow: Object,
  run_parameters: Object,
  isnamespace: Boolean,
  viewlog: Boolean,
  moreOptions: Boolean, 
  hideOnBoardingMsg: Boolean,
  runName: String,
},
  emits: [
  "flowSave", "logFound", "closeLog", "toggleLock", "resetRun", "loading", "toggleOnBoardingMsg", "flowCache", "loadFromStore"
],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const vfInstance = ref();


const snapGrid: SnapGrid = [20, 20];
const mountNode = ref(false);
const mountEdge = ref(false);
const contextOpen = ref(false);
const mousePosition = ref();
const currentElement = ref<Node>();
const currentElementHandles = ref({ source: {}, target: {} });
const currentConnection = ref<Edge>()
let eleIDcounter = 0;
const k8sAdminAPIEndPoint = inject('back_end_admin_API_end_point');
const userAPIEndPoint = inject('back_end_user_services_API_end_point');
const authAPIEndPoint = inject('auth_API_end_point');
const userJWTToken = inject('userJWTToken');
const dataToFile = ref({
    components: props.components,
    connections: props.connections,
    workflow: props.workflow,
    run_parameters: props.run_parameters,
})
const serverInputData = ref()
const allCompNames = ref()
const startIsSet = ref(false);
const endIsSet = ref(false);
const driverIsSet = ref(false);
const hasIncomingConnections = ref(false)
const hasOutgoingConnections = ref(false)
const nodeVisibility = ref(true)
const nodesToMountInBackground = ref(Array())
const allCompValidity = ref(false)
const userQuotasCheck = ref()
const startPending = ref(false)
const pausePending = ref(false) 
const stopPending = ref(false) 
const startisDisabled = ref(true);
const pauseisDisabled = ref(true);
const stopisDisabled = ref(true);
const restart = ref(false);
const isNamespace = ref(false) 
const toggleLock = ref(false)
const flowIslocked = ref(false)
const logStream = ref()
const logStreamStopped = ref(true)
const viewRunLog = ref(props.viewlog)
const runLog = ref()
const moreOptions = ref(props.moreOptions)
const onBoardingMsg = ref(true)
const userSecrets = ref(false)
const userAppTokens = ref(Array())
const userAppTokensValid = ref(false)
const hideOnBoardingMsg = ref(props.hideOnBoardingMsg)
const nodeFormTemplate = ref()
const userResourceStats = ref({
  storage: { val: "N/A", pc: "N/A" },
  pods: { val: "N/A", pc: "N/A" },
  cpu: {val: "N/A", pc: "N/A"},
  memory: {val: "N/A", pc: "N/A"},
})
const runName = ref(props.runName)
const lastSaved = ref()
const canvas = ref()

const addSecretItem = () => { 
  console.log("add secret ")
  userAppTokens.value.push({name:"", value:""})
}

const deleteSecretItem = (index = -1) => { 
  console.log("delete secret of index ", index)
  userAppTokens.value.splice(index, 1);
}

const getUserAppTokensValidity = () => { 
  userAppTokensValid.value = !(userAppTokens.value.filter(e =>
    /^[a-zA-Z0-9]([-a-zA-Z0-9]*[a-zA-Z0-9])?$/.test(e.name) == false
      || /^[a-zA-Z0-9]([-a-zA-Z0-9]*[a-zA-Z0-9])?$/.test(e.value) == false).length > 0)
}

const check = (e) => {
  // toggle hideOnBoardingMsg
  console.log("hideOnBoardingMsg.value", hideOnBoardingMsg.value)
  emit("toggleOnBoardingMsg",hideOnBoardingMsg.value)
}

const componentStyle = {
          border: "1px solid #rgb(66, 66, 66)",
          padding: "0px",
          height: "300px",
          width: "300px",
          background: "rgb(66, 66, 66)",
}
const connectionStyle = (edge) => {
  switch (edge.data.type) { 
      case "implicit":
        edge.style.stroke = "rgb(0, 255, 64)"
        break;
      case "setup":
        edge.style.stroke = "rgb(0, 0, 255)"
        break;
      case "design": 
        edge.style.stroke = "black"
        break; 
      default: // "should not occur"
        edge.style.stroke = "rgb(197, 197, 197)"
    }
}

const checkFlowLockToggled = () => { 
  if (toggleLock.value) {
    toggleLock.value = false //reset
    flowIslocked.value = !flowIslocked.value;
    emit("toggleLock",flowIslocked.value)
  }
}

const allComps = () => { return elements.value.filter(e => e.type === "selectorNode")}

const checkUserResourceQuotas = () => {
  // constrain number of components to number of pods -2 (for controller and memcache)
  const podsQuota =  Number(userResourceQuotas.pods)
  if (allComps().length + 2 > podsQuota) {
    alert(` \u274C Exceeding user resource quota: Reduce number of components to ${podsQuota-3} or less.`)
    return false
  }
  return true
}

const updateFlowVariables = async (flowCache) => {
  allCompNames.value = allComps().map(e => e.data?.orchName)
  if (allComps().length && flowIslocked.value == false) {
    startIsSet.value = allComps().some(e => e.data.isStart == true)
    endIsSet.value = allComps().some(e => e.data.isEnd == true)
    driverIsSet.value = allComps().some(e => e.data.isDriver == true)
    allCompValidity.value = allComps().every(e => e.data.validity === "valid")
    userQuotasCheck.value = checkUserResourceQuotas()

    startisDisabled.value = (allCompValidity.value && startIsSet.value && endIsSet.value && userQuotasCheck.value) ? false : true
  } else {
    startisDisabled.value = true
  }
  if (flowCache) {
    await logToObject(false)
  }
  console.warn("updateFlowVariables")
}

const onNodeDragStop = ({ node }) => console.log("drag stop");
const onElementClick = async ({ element }) => {
  console.log("click", element);
  if (isEdge(element)) {
    console.log(element.label);
    currentConnection.value = element;
    mountEdge.value = true;
  } else {
    canvas.value = await Shared.methods.getScreenshot()
    mountNodeForm(element, true);
    console.log("show dialogue for ", currentElement.value?.id);
  }
};

const mountNodeForm = async (element, visibility) => { 
    // console.warn("MountNodeForm of element", element)
    const allConnections = elements.value.filter((el) => el.type === "customline" &&  el.data.type !== "setup")
    hasIncomingConnections.value = allConnections.filter((el) => el.target === element.id).length > 0
    hasOutgoingConnections.value = allConnections.filter((el) => el.source === element.id).length > 0
    currentElement.value = element;
    nodeVisibility.value = visibility;
    mountNode.value = true;
}

const onNodeFormMounted = () => { 
  if (nodeVisibility.value == false) { 
    confirmComponent()
  }
}

const onNodeFormUnMounted = () => { 
  if (nodeVisibility.value == false) {
    // allows a connection's source and target to be checked sequentially
    // occurs when a connection is created or deleted, as this can affect comp. validity     
    if (nodesToMountInBackground.value.length) {
      startCheckingNodesInBackground()
    } else { 
      if (isNamespace.value) { 
        startisDisabled.value = true;
        startPending.value = true;
        pauseisDisabled.value = true;
        pausePending.value = true;
        stopisDisabled.value = true;
        stopPending.value = true;        
        toggleLock.value = true;
        call_log_stream()
      }
      emit("loading", false)
    }
  }
}

const nodeFormReportSave = (data) => { 
    alert("\u274C FILE UPLOAD ERROR: see dapta_upload_error.json for details.")
    emit("flowSave", JSON.stringify(data, null, 2), "dapta_upload_error.json"); // this triggers saveToFile function in Interface
}

const elements = ref<Elements>([]);
const setElements = function () {
  elements.value = [];
  if (props.components) {
    for (let i = 0; i <= props.components.length - 1; i++) {
      elements.value.push({
        id: props.components[i].name,
        type: "selectorNode",
        data: {
          orchName: props.components[i].name,
          orchApi: props.components[i].api,
          orchApiInputFiles: null,
          orchOptions: props.components[i].options,
          orchParameters: props.components[i].parameters,
          orchInputs: props.components[i].inputs,
          orchOutputs: props.components[i].outputs,
          validity: "pending",
          runstatus: {
            status: "sleep",
            time: "",
            iterations: 0,
          },
          componentEventsLog: "",
          isStart: false,
          isEnd: false,
          isDriver: false,
        },
        style: componentStyle,
        position: props.components[i].appmeta?.position ? props.components[i].appmeta?.position : { x: i * 20, y: i * 20 },
      });
    }
  }

  if (props.connections) {
    for (let i = 0; i <= props.connections.length - 1; i++) {
      elements.value.push({
        id: props.connections[i].name_origin,
        type: "customline",
        label: props.connections[i].name_origin,
        source: props.connections[i].origin,
        sourceHandle: props.connections[i].name_origin,
        target: props.connections[i].target,
        targetHandle: props.connections[i].name_target,
        style: {
          stroke: "rgb(197, 197, 197)",
        },
        data: {
          type: props.connections[i].type? props.connections[i].type : "design",
        },
        updatable: false,
      });
      console.log("connection object: ", elements.value[elements.value.length - 1])
      connectionStyle(elements.value[elements.value.length - 1])
    }
  }

  if (props.workflow) { 
    if ("start" in props.workflow) { 
      const index = elements.value.findIndex(e => e.type === "selectorNode" && e.id === props.workflow.start);
      elements.value[index].data.isStart = true;
    }
    if ("end" in props.workflow) { 
      const index = elements.value.findIndex(e => e.type === "selectorNode" && e.id === props.workflow.end);
      elements.value[index].data.isEnd = true;
    }
    if ("driver" in props.workflow) { 
      const index = elements.value.findIndex(e => e.type === "selectorNode" && e.id === props.workflow.driver);
      elements.value[index].data.isDriver = true;
    }
  }

  if (props.run_parameters) { 
    if ("name" in props.run_parameters) { 
      runName.value = props.run_parameters["name"]
    }
    if (props.run_parameters.appmeta?.mtime) { 
      lastSaved.value = props.run_parameters.appmeta.mtime
    }
  }

  // run validation check on all components
  if (props.components) {
    nodesToMountInBackground.value = allComps().map(e => e.id)
    // validation is started in onLoad or in watch of props
  }

  updateFlowVariables(false)
  // console.log(elements.value);
};
setElements();
eleIDcounter = elements.value.length;

const startCheckingNodesInBackground = async () => { 
  const eid = nodesToMountInBackground.value.pop()
  const ele = elements.value.find(e => e.type === "selectorNode" && e.id === eid)
  console.warn(`startCheckingNodesInBackground for ${eid}`)
  emit("loading", true)
  mountNodeForm(ele, false) // check validity
}

const onElementsRemove = (elementsToRemove: Elements) => {

  if (elementsToRemove.some(e => e.type === "customline" && e.data.type !== "setup")) {
    // collect ids of the source and target components
    const connections = elementsToRemove.filter(e => e.type === "customline" && e.data.type !== "setup")
    for (let i = 0; i <= connections.length - 1; i++) {
      if (!nodesToMountInBackground.value.includes(connections[i].source)) { 
        nodesToMountInBackground.value.push(connections[i].source)
      }
      if (!nodesToMountInBackground.value.includes(connections[i].target)) { 
        nodesToMountInBackground.value.push(connections[i].target)
      }
    }
  }

  removeElements(elementsToRemove, elements.value);
  console.log("element removed: ", elementsToRemove);
};

const onConnect = (params: Connection | Edge) => {
  if (flowIslocked.value == false) {
  const newID = eleIDcounter;
  eleIDcounter += 1;
  const newconnection: Edge = {
    id: newID,
    type: "customline",
    label: params.sourceHandle,
    ...params,
    style: {
      stroke: "rgb(197, 197, 197)",
    },
    data: {
      type: "design"
    },
    updatable: false,
  };
  elements.value.push(newconnection);
  connectionStyle(elements.value[elements.value.length - 1])

  nodesToMountInBackground.value.push(newconnection.source, newconnection.target) // wait until source check completed then check validity or target
  startCheckingNodesInBackground()
  
  console.log("connection added: ", newID, params);
  }
};

const logToObject = async (trigger_download) => {
  const vueflowOut = vfInstance.value?.toObject();
  // const path = ev.target.files[0].path;
  const appComponents = vueflowOut.elements
    .filter((el) => el.type === "selectorNode")
    .map((ele) => {
      const node = {
        name: ele.data.orchName,
        api: ele.data.orchApi,
        options: ele.data.orchOptions,
        parameters: ele.data.orchParameters,
        inputs: ele.data.orchInputs,
        outputs: ele.data.orchOutputs,
        appmeta: {
          apiInputFiles: ele.data.orchApiInputFiles,
          validity: ele.data.validity,
          id: ele.id,
          position: ele.position,
        },
      };
      return node;
    });
  const appConnections = vueflowOut.elements
    .filter((el) => el.type === "customline")
    .map((ele) => {
      const connection = {
        origin: vueflowOut.elements.filter((el) => el.type === "selectorNode" && el.id === ele.source).map((el) => el.data.orchName)[0],
        name_origin: ele.sourceHandle,
        target: vueflowOut.elements.filter((el) => el.type === "selectorNode" && el.id === ele.target).map((el) => el.data.orchName)[0], 
        name_target: ele.targetHandle,
        type: ele.data.type,
        appmeta: {
          id: ele.id,
          label: ele.label,
        },
      };
      return connection;
    });
  const workFlowData = {"start":"isStart", "end":"isEnd", "driver":"isDriver"}
  for (const [key, value] of Object.entries(workFlowData)) { 
    const element = vueflowOut.elements.find(e => e.type === "selectorNode" && e.data[value] == true)
    element ? workFlowData[key] = element.data.orchName : delete workFlowData[key]
  }
  const runParameters = props.run_parameters ? props.run_parameters : Object()
  runParameters["name"] = runName.value
  "appmeta" in runParameters ? "" : runParameters["appmeta"] = {
    "filename": "dapta_input.json", "mtime": null
  }
  const newDataValues = {
    components: appComponents,
    connections: appConnections,
    workflow: workFlowData,
    run_parameters: runParameters,
  };
  if (!_.isEqual(newDataValues, dataToFile.value)) { 
    newDataValues.run_parameters.appmeta.mtime = null
    console.log("resetting run_parameters.appmeta.mtime")
    dataToFile.value = newDataValues
  };
  if (trigger_download) {
    emit("flowSave", JSON.stringify(dataToFile.value, null, 2), "dapta_input.json"); // this triggers saveToFile function in Interface
    console.log("Saving input to file.");
    if (isNamespace.value) {
      await getStatus()
      emit("flowSave", runLog.value, "runlog.json"); // this triggers saveToFile function in Interface
      console.log("Saving input to file.");
    }
  } else { 
    emit("flowCache", JSON.stringify(dataToFile.value, null, 2));
  }
};

const confirmComponent = (isSplash = false) => {
  mountNode.value = false;
  mountEdge.value = false;
  viewRunLog.value = false;
  moreOptions.value = false;
  userSecrets.value = false;
  if (isSplash) { 
    onBoardingMsg.value = false;
  }
  emit("closeLog")
};

const updatePos = function () {
  // update the node positions to match the sreen size
  const nodeXoffset = Number.parseFloat(
    getComputedStyle(document.querySelectorAll(".node-template")[0]).width
  );
  for (let i = 1; i <= elements.value.length - 1; i++) {
    if (elements.value[i].type === "selectorNode") {
      elements.value[i].position.x = (nodeXoffset + 200) * i;
      elements.value[i].position.y = (nodeXoffset / 5 + 100) * i;
    }
  }
};

const onLoad = (flowInstance: FlowInstance) => {
  // console.log(document.querySelectorAll(".node-template"))
  // if (document.querySelectorAll(".node-template").length > 0) updatePos();
  flowInstance.fitView({ padding: 0.1 });
  vfInstance.value = flowInstance;
  console.log("flow loaded:", flowInstance);

  if (nodesToMountInBackground.value.length) {
    console.warn("Viewflow onLoad")
    startCheckingNodesInBackground()
  }

  console.log("Vueflow instance is loaded ...")
};

onUpdated(() => {
  // triggers whenever Vue re-renders or patches the DOM
  
  // if (event && event?.type === "load" && document.querySelectorAll(".node-template").length > 0) {
  //   updatePos();
  //   //  vfInstance.value?.fitView(); doesn't work - always does fit-view on elements pre-update
  //   console.log("updated elements view");
  //   };

  checkFlowLockToggled()  
  console.log("Vue updated...")
});

onMounted(async () =>{ 
  // triggers whenever component is first mounted to the DOM
  console.warn("CustomEditableNode mounted.")
  isNamespace.value = props.isnamespace
  onBoardingMsg.value = !hideOnBoardingMsg.value
  checkFlowLockToggled()
})

watch(
  () => [props.components, props.connections, props.run_parameters],
  (newval, oldval) => {
    if (vfInstance.value) {
      setElements();
      if (nodesToMountInBackground.value.length) {
        console.warn("watch on Viewflow props triggered.")
        startCheckingNodesInBackground()
      }
    }
  }
);

const removeConnections = function (
  elid,
  oldHandles,
  newHandles,
  type: string
) {
  // find handles that have been removed
  const missing = new Array();
  oldHandles.forEach((handle) => {
    if (newHandles.indexOf(handle) === -1) {
      missing.push(handle);
    }
  });

  console.log("handles to be removed:", missing);
  // delete connections to the removed handles
  let removedElements;
  for (const handle of missing) {
    if (type === "target") {
      removedElements = elements.value.filter(
        (el) =>
          el.type === "customline" &&
          el.target === elid &&
          el.targetHandle === handle
      );
    } else if (type === "source") {
      removedElements = elements.value.filter(
        (el) =>
          el.type === "customline" &&
          el.source === elid &&
          el.sourceHandle === handle
      );
    }
    console.log("connections to be removed:", removedElements);
    if (removedElements) onElementsRemove(removedElements);
  }
};

const deleteComp = async (compid) => {
  confirmComponent();
  let removedElements = elements.value.filter(
        (el) =>
          el.type === "selectorNode" &&
          el.id === compid
      );
  if (removedElements) {
    if (removedElements[0].data.orchName) {
      await Shared.methods.call_be_api_delete_files(k8sAdminAPIEndPoint, userJWTToken.value, removedElements[0].data.orchName, null, null, runName.value)
    }
    onElementsRemove(removedElements)
    if (nodesToMountInBackground.value.length) {startCheckingNodesInBackground()}
    updateFlowVariables(true)
  }
}

const deleteConnection = async (connectid) => {
  confirmComponent();
  let removedElements = elements.value.filter(
        (el) =>
          el.type === "customline" &&
          el.id === connectid
      );
  if (removedElements) {
    onElementsRemove(removedElements)
    if (nodesToMountInBackground.value.length) {startCheckingNodesInBackground()}
    updateFlowVariables(true)
  }
}

const updateComp = async (newcomp, keepOpen, saveRun = false) => {
  if (!keepOpen && mountNode.value) confirmComponent();
  const comp = elements.value.find((elements) => elements.id === newcomp.id);
  comp.data.orchName = newcomp.orchName;
  comp.data.orchApi = newcomp.orchApi;
  comp.data.orchApiInputFiles = _.cloneDeep(newcomp.orchApiInputFiles);
  comp.data.orchOptions = _.cloneDeep(newcomp.orchOptions);
  comp.data.orchParameters = _.cloneDeep(newcomp.orchParameters);
  comp.data.isStart = newcomp.isStart;
  comp.data.isEnd = newcomp.isEnd;
  comp.data.isDriver = newcomp.isDriver;

  if (
    comp.data.orchInputs &&
    Object.keys(comp.data.orchInputs) !== Object.keys(newcomp.orchInputs)
  ) {
    removeConnections(
      comp.id,
      Object.keys(comp.data.orchInputs),
      Object.keys(newcomp.orchInputs),
      "target"
    );
  }
  if (
    comp.data.orchOutputs &&
    Object.keys(comp.data.orchOutputs) !== Object.keys(newcomp.orchOutputs)
  ) {
    removeConnections(
      comp.id,
      Object.keys(comp.data.orchOutputs),
      Object.keys(newcomp.orchOutputs),
      "source"
    );
  }
  comp.data.orchInputs = _.cloneDeep(newcomp.orchInputs);
  comp.data.orchOutputs = _.cloneDeep(newcomp.orchOutputs);
  comp.data.validity = newcomp.validity;

  await updateFlowVariables(true) // udates dataToFile in logToObject

  if (saveRun) {
    console.warn("call_be_api_upload after component update")    
    await call_be_api_upload(false)
  }

  console.log("Saved component: ", comp);
  // close the dialog
};

const updateConnection = (newConnection) => {
  confirmComponent();
  const edge = elements.value.find((elements) => elements.id === newConnection.id);
  edge.label = newConnection.label;
  edge.data.type = newConnection.orchType;
  connectionStyle(edge)
  console.log("Saved component: ", edge);
  // close the dialog
};

const getHandleBounds = function (bounds, height, width, data, position) {
  console.log("before update:", bounds, data);
  const newBounds = new Array();
  const usedIndices = new Array();
  for (const handle of bounds) {
    const index = data.findIndex((obj) => obj.id === handle.id);
    const matchedHandle = data[index];
    // remove handles that are not in data
    if (matchedHandle) {
      // adjust the vertical position of the connections to match handle locations
      handle.y =
        (height * matchedHandle.data.offsetTop) / 100 - handle.height / 2;
      newBounds.push(handle);
    }
    usedIndices.push(index);
  }
  // add new handles
  const newData = data.filter(
    (val, index) => usedIndices.indexOf(index) === -1
  );
  if (newData.length > 0) {
    for (const handle of newData) {
      const defaultHandle = {
        height: 8,
        width: 8,
        id: "",
        position: position,
        x: position === "left" ? -4 : width - 4,
        y: 0,
      }; // keep style consistent with the other handles
      defaultHandle.id = handle.id;
      defaultHandle.y =
        (height * handle.data.offsetTop) / 100 - defaultHandle.height / 2;
      newBounds.push(defaultHandle);
      console.log("add handle ", defaultHandle);
    }
  }
  console.log("after update", newBounds);
  return newBounds;
};

const updateHandles = (data) => {
  if (!nodeVisibility.value) return // on initial load this function is skipped

  // cache the handle locations from the node component
  currentElementHandles.value.source = data.find((obj) => {
    return obj.type === "source";
  });
  currentElementHandles.value.target = data.find((obj) => {
    return obj.type === "target";
  });

  // update the handle bounds
  const comp = elements.value.find(
    (elements) => elements.id === currentElementHandles.value.source.id
  );
  if (comp && comp.__vf) {
    if (!comp.__vf.handleBounds.source)
      comp.__vf.handleBounds.source = new Array();
    if (!comp.__vf.handleBounds.target)
      comp.__vf.handleBounds.target = new Array();

    comp.__vf.handleBounds.source = getHandleBounds(
      comp.__vf.handleBounds.source,
      comp.__vf.height,
      comp.__vf.width,
      currentElementHandles.value.source.handles,
      "right"
    );

    comp.__vf.handleBounds.target = getHandleBounds(
      comp.__vf.handleBounds.target,
      comp.__vf.height,
      comp.__vf.width,
      currentElementHandles.value.target.handles,
      "left"
    );
  } else console.log("Error: could not find node.__vf to update handle bounds.");

  // this is triggered if handles on a node were edited, added or removed
  if (nodesToMountInBackground.value.length) {startCheckingNodesInBackground()}
  updateFlowVariables(true)    
};

// ------------------------------------------ Start - context-menu
const onRightClick = function (e) { 
  if (flowIslocked.value == false) {
    mousePosition.value = { x: e.pageX, y: e.pageY }
  contextOpen.value = true;
  window.addEventListener("click", listener); 
  }
}
const listener = (e) => {  
  callback_fn();
}

const callback_fn = function () {
  contextOpen.value = false;
  window.removeEventListener('click', listener); 
  };

const atMousePos = computed(
  () => `top: ${mousePosition.value.y}px; left: ${mousePosition.value.x}px`
);

const getCurrentViewTransform = function () {
  const para = document.getElementsByClassName('vue-flow__nodes');
  const compStyles = window.getComputedStyle(para[0]);
  const tmat = compStyles.getPropertyValue('transform').slice(7,-1).split(",") ; 
  const yoffset = 50 // derived from #vue-flow, top: 50px; TODO: to be linked somehow
  // console.log(tmat)
  return [tmat, yoffset]
}

const AddEmptyNode = function () {
  const newID = eleIDcounter;
  eleIDcounter += 1;
  const [tmat, yoffset] = getCurrentViewTransform()
  const xnode = (mousePosition.value.x - tmat[4])/ tmat[0]
  const ynode = (mousePosition.value.y - tmat[5] - yoffset)/ tmat[3]
  // console.log(tmat, yoffset, xnode, ynode)
  elements.value.push({
    id: newID,
    type: "selectorNode",
    data: {
      orchName: `component-${newID}`,
      orchApi: null,
      orchApiInputFiles: null,
      orchOptions: null,
      orchParameters: null,
      orchInputs: null,
      orchOutputs: null,
      validity: "pending",
      runstatus: {
        status: "sleep",
        time: "",
        iterations: 0,
      },
      componentEventsLog: "",
      isStart: false,
      isEnd: false,
      isDriver: false,
    },
    style: componentStyle,
    position: { x: xnode , y: ynode},
  });
  updateFlowVariables(true)
  console.log("Added Empty Node with ID ", newID)
}
// ------------------------------------------ End - context-menu

const getStart = async () => {
  const currentlyPaused = pausePending.value;

  let name
  [isNamespace.value, name] = await Shared.methods.call_get_Namespace_exists(k8sAdminAPIEndPoint, userJWTToken.value, "any", true)
  if (name !== null && name !== runName.value) {
    if (confirm("\u274C User resource limit reached: Another run is already being executed.\n\nLoad the active run? \n" + name)) {
      console.warn("emit loadFromStore")
      emit("loadFromStore", name, { beApiTerminate: false })
    }
    return;
  }

  try {
    startPending.value = true;
    pausePending.value = false;
    stopPending.value = false;

    startisDisabled.value = true;
    pauseisDisabled.value = true;
    stopisDisabled.value = true;

    !flowIslocked.value && (toggleLock.value = true)
    checkFlowLockToggled()

    if (!currentlyPaused) {

      await logToObject(false)

      // 1. notify user and terminate conditions for restart are met
      if (isNamespace.value) {
        if (!logStream.value) { 
          alert("\u26A0 This run has already been executed. Getting latest status from server.")
          logStreamStopped.value && call_log_stream()
          return;
        }

        if (confirm("Warning: The existing run and associated output data will be deleted. \nDo you want to continue?") == false) {
            console.log("cluster reset cancelled by user -> exiting getStart().")
            startisDisabled.value = false;
            startPending.value = false;
            flowIslocked.value && (toggleLock.value = true)
            return
        }

        // delete all output files
        for (let i = 0; i <= allCompNames.value.length - 1; i++) { 
          await Shared.methods.call_be_api_delete_files(k8sAdminAPIEndPoint, userJWTToken.value, allCompNames.value[i], "outputs", null, runName.value)
        }
   
        emit("logFound", false)

        let termination_flag = await get_termination_flag()
        if (termination_flag) {
          await Shared.methods.call_be_api_terminate(k8sAdminAPIEndPoint, userJWTToken.value)
          isNamespace.value = false
        } else { console.log("No k8s restart required.") }
      }

      // 2. upload input file to user cloud storage
      await call_be_api_upload()

      // 3. run setup as required
      if (!isNamespace.value) {
        await call_be_api_setup()
        isNamespace.value = await Shared.methods.call_get_Namespace_exists(k8sAdminAPIEndPoint, userJWTToken.value, true)
        if (!isNamespace.value) {
          throw Error("Namespace failed to be created -> exiting getStart().")
        }
      }
    }

    // 4. execute call to start run
    if (isNamespace.value) {
      await call_user_api_start()
      call_log_stream()
    } else { 
      throw Error("Namespace could not be found. -> exiting getStart().")
    }

  } catch (err) {
    startisDisabled.value = false;
    startPending.value = false;
    pausePending.value = currentlyPaused;
    flowIslocked.value && (toggleLock.value = true)
    throw err
  } 
};

const get_saved_run = async () => { 
  // 1. read previous input file from server
  serverInputData.value = await Shared.methods.call_be_api_download(k8sAdminAPIEndPoint, userJWTToken.value, runName.value)
  return serverInputData.value
}

const get_termination_flag = async () => { 
  console.log("Checking conditions for user cluster restart...")

  // 1. read previous input file from server 
  await get_saved_run()

  // 2. compare server input with new input
  if (dataToFile.value.components.length) {
    for (let i = 0; i <= dataToFile.value.components.length - 1; i++) {
      let name = dataToFile.value.components[i].name
      let image = dataToFile.value.components[i].api

      if (serverInputData.value.components.length) {
        const matchingComp = serverInputData.value.components.findIndex(e => (e.name === name && e.api === image))
        if (matchingComp >= 0) { 

          const refComp = serverInputData.value.components[matchingComp]
          const newComp =  dataToFile.value.components[i]
          // do check on the component
          if ((refComp.options.replicas || newComp.options.replicas) && refComp.options.replicas!=newComp.options.replicas) {
            console.log(`changed number of replicas for component ${name} >> restart required`)
            return true
          }
          
          serverInputData.value.components.splice(matchingComp,1)
        } else { 
          // user component was added or modified
          console.log(`component ${name} was added or modified >> restart required`)
          return true
        }
      } else {
        // no user components on server
        console.log("no user components on server >> restart required")
        return true
      }      
    }

    if (serverInputData.value.components.length) { 
      // a user component was removed
      console.log("a user component was removed >> restart required")
      return true
    }
  }

  return false
}

const setRunParameters_appmeta = () => {
  const now = new Date()
  dataToFile.value.run_parameters.appmeta = dataToFile.value.run_parameters.appmeta || {};
  dataToFile.value.run_parameters.appmeta.mtime = now.toISOString()
  lastSaved.value = now.toISOString()
  console.log("setRunParameters_appmeta", dataToFile.value.run_parameters.appmeta.mtime)
}

const call_be_api_upload = async (getScreenshot=true) => { 
  console.log("Upload dapta_input.json");
  setRunParameters_appmeta()
  if (getScreenshot) {
    canvas.value = await Shared.methods.getScreenshot()
  }
  await Shared.methods.uploadScreenshot(k8sAdminAPIEndPoint, userJWTToken.value, runName.value, canvas.value)
  const data = new URLSearchParams({
    run_name: String(runName.value)
  })
  await fetch(k8sAdminAPIEndPoint + "/uploadjson?" + data, {
    method: "POST",
    headers: { "Authorization": `Bearer ${userJWTToken.value}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(dataToFile.value, null, 2)
  }).then(Shared.methods.handleErrors);
}

const deleteMultipleFiles = async (component, subfolder, filenames) => { 
  console.log("Delete multiple files by filename list.");
  for (var j = 0; j < filenames.length; j++) { 
    await Shared.methods.call_be_api_delete_files(k8sAdminAPIEndPoint, userJWTToken.value, component, subfolder, filenames[j], runName.value)
  }
  nodeFormTemplate.value.getParamInputFiles()
}

const call_be_api_setup = async () => { 
  console.log("Set up user k8s namespace.");
  const data = new URLSearchParams({
    run_name: String(runName.value)
  })
  await fetch(k8sAdminAPIEndPoint +"/setup?" + data, {
    method: "POST",
    headers: { "Authorization": `Bearer ${userJWTToken.value}`}
  }).then(Shared.methods.handleErrors)
}

const call_user_api_start = async () => { 
  const data = new URLSearchParams({
    run_name: String(runName.value)
  })
  let route;
  if (restart.value) {
    route = userAPIEndPoint + "/restart";
  } else {
    route = userAPIEndPoint + "/start?" + data;
  }
  console.log("START orch");
  await fetch(route, {
    method: "GET",
    headers: {"Authorization": `Bearer ${userJWTToken.value}`}
  }).then(Shared.methods.handleErrors)
    .then((response) => {
          if (response.ok) {
            console.log(response)
            return response.json();
      }
  }).then((data) => { 
      console.log(data);
  })
}

const call_log_stream = async (silent=false) => {
  console.log("Listen to server log.");
  const controller = new AbortController();
  const signal = controller.signal; 
  logStreamStopped.value = false;

  const response = await fetch(userAPIEndPoint + "/log_stream", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` },
    signal: signal
  }).then(Shared.methods.handleErrors)

  let counter = 0
  const reader = response.body.getReader();
  async function read(reader) {
    const {value, done} = await reader.read();

    if (done) {
      logStreamStopped.value = true;
      controller.abort()
      updateRunstatus(logStreamStopped.value, silent)
      return;
    }
    const decoder = new TextDecoder();
    const logContent = decoder.decode(value).split(/\r?\n/);
    for (let i = 0; i < logContent.length; i++) {
      if (logContent[i].length > 10) { // skip empty chunks and timestamps
        if (logContent[i].search(/"/g) == -1) {
            logStream.value = JSON.parse(logContent[i].replace(/'/g, '"'))
        } else { 
            logStream.value = JSON.parse(logContent[i])
        }
        counter += 1
        console.log(counter, logStream.value)
        updateRunstatus(logStreamStopped.value, silent)
      }
    }

    emit("logFound", true)
    return read(reader);
  }
  await read(reader)
    // .catch(async () => {
    //   controller.abort()
    //   console.error("Fetching logStream failed. Try again in 5s.")
    //   await Shared.methods.sleep(5000);
    //   call_log_stream()
    // });
  console.log("Finished!");
}

const resetControls = () => { 
    startPending.value = false;
    pausePending.value = false;
    stopPending.value = false;

    startisDisabled.value = false;
    pauseisDisabled.value = true;
    stopisDisabled.value = true;

    // stopLogStream.value = true;
    restart.value = false;
    flowIslocked.value && (toggleLock.value = true)
}

const getUserStorage = async () => {
  console.warn("getUserStorage")
  await fetch(k8sAdminAPIEndPoint + "/checkstoragequota", {
    method: "GET",
    headers: {"Authorization": `Bearer ${userJWTToken.value}`}
  }).then(Shared.methods.handleErrors)
    .then((response) => {
          if (response.ok) {
            console.log(response)
            return response.json();
      }
    }).then((data) => { 
      userResourceStats.value.storage.val = Math.ceil(data.used_storage_MB);
      userResourceStats.value.storage.pc = Math.ceil(data.pc_used);
      if (data.pc_used >= 80.0) { 
      alert(`\u26A0 You are using ${data.used_storage_MB}MB = ${Math.ceil(data.pc_used)}% of your allocated file storage. \nView the run Log for details. \n \n WARNING: your run may fail when 100% of storage is used.`)
      }
  })  
}

const userStatsDisplay = async () => {
  await getUserStorage()
  getUserStats()
  alert(`User resource usage stats: 
          \n Storage: ${userResourceStats.value.storage.pc}% used / ${userResourceStats.value.storage.val} Mbi.
          \n Pods: ${userResourceStats.value.pods.pc}% used / ${userResourceStats.value.pods.val} 
          \n CPU:  ${userResourceStats.value.cpu.val} cpu
          \n Memory: ${userResourceStats.value.memory.val} Gbi`)
}

const getUserStats = async () => {
  console.warn("getUserStats")
  if (isNamespace.value) {
    await fetch(k8sAdminAPIEndPoint + "/checkuserstats", {
      method: "GET",
      headers: { "Authorization": `Bearer ${userJWTToken.value}` }
    }).then(Shared.methods.handleErrors)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).then((data) => {
        console.log(data)
        userResourceStats.value.pods.val = data.pods_used - 2; // excluding system pods 
        userResourceStats.value.pods.pc = data.pods_pc_used;
        userResourceStats.value.cpu.val = Math.round(data.cpu_used)/1000;
        // userResourceStats.value.cpu.pc = Math.round(data.cpu_pc_used);
        userResourceStats.value.memory.val = Math.round(data.memory_used*1000)/1000;
        // userResourceStats.value.memory.pc = Math.round(data.memory_pc_used);
      })
    }
}

const updateRunstatus = (stopped, silent=false) => { 
  // update the interface control buttons 
  if (stopped == true && Object.keys(logStream.value.errorlog).length > 0) {
    resetControls()
    if (!(logStream.value.statuslog.orchestrator.status === "stopped")) {
      let msg = " \u274C Run error occured: Check components for details.\n"
      if ("orchestrator" in logStream.value.errorlog) {
        msg = "Orchestrator error found: \n"
        const err = logStream.value.errorlog["orchestrator"]
        msg += `${err.time} -- ${err.details}\n`
      }
      !silent && alert(msg);
    }
  } else if ("orchestrator" in logStream.value.statuslog) {
    const status = logStream.value.statuslog.orchestrator.status
    if ((status === "setup" || status === "executing") && startPending.value) {
      startPending.value = false;
      pausePending.value = false;
      stopPending.value = false;

      startisDisabled.value = true;
      pauseisDisabled.value = false;
      stopisDisabled.value = false;
    }
    if (stopped == true && status === "paused" && pausePending.value) {
      startPending.value = false;
      // pausePending remains true as long as the run is paused
      stopPending.value = false;

      startisDisabled.value = false;
      pauseisDisabled.value = true;
      stopisDisabled.value = false;

      restart.value = true;
      !silent && alert("PAUSED: click \u23F5 to continue Run execution.");
    }
    if (stopped == true && status === "stopped" && stopPending.value) {
      resetControls()
      !silent && alert("STOPPED: click \u23F5 to restart Run execution.");
    }
    if (stopped == true && status === "completed") {
      resetControls()
      !silent && alert("\u2714 The Run has completed successfully.");
    }
  } else { 
    const e = logStream.value.events
    if ( !e.start && !e.pause && !e.stop ) 
      // this occurs if starting the orchestrator failed or the logstream is called before start
      resetControls()
      stopped = true
  }

  // update run status for all components
  if (stopped != true) {
    allComps().map(e => {
      const name = e.data.orchName
      if (name in logStream.value.errorlog) {
        const err = logStream.value.errorlog[name]
        const s = {
          "status": "error",
          "time": err.time,
          "iterations": logStream.value.statuslog[name].iterations
        }
        if (!_.isEqual(toRaw(e.data.runstatus),s)) {
          e.data.runstatus = s;
          e.data.componentEventsLog += `${err.time} -- ${"error".toUpperCase().padEnd(7, ' ')} -- ${err.code} -- ${err.details}\n`
        }
      } else if (logStream.value.statuslog.orchestrator.status === "stopped") {
        const sta = logStream.value.statuslog.orchestrator
        const s =  {
          "status": sta.status,
          "time": sta.time,
          "iterations": logStream.value.statuslog[name].iterations
        }
        if (!_.isEqual(toRaw(e.data.runstatus),s)) {
          e.data.runstatus = s;
          e.data.componentEventsLog += `${sta.time} -- STOPPED by user.\n`
        }
      } else if (logStream.value.statuslog.orchestrator.status === "paused") {
        const sta = logStream.value.statuslog.orchestrator
        const s =  {
          "status": sta.status,
          "time": sta.time,
          "iterations": logStream.value.statuslog[name].iterations
        }
        if (!_.isEqual(toRaw(e.data.runstatus),s)) {
          e.data.runstatus = s;
          e.data.componentEventsLog += `${sta.time} -- PAUSED by user.\n`
        }
      } else if  (name in logStream.value.statuslog) {
        const sta = logStream.value.statuslog[name]
        const s =  {
          "status": sta.status,
          "time": sta.time,
          "iterations": sta.iterations
        }
        if (!_.isEqual(toRaw(e.data.runstatus),s)) {
          console.log("run status, ", toRaw(e.data.runstatus));
          console.log("new status: ", s);
          e.data.runstatus = s;
          e.data.componentEventsLog += `${sta.time} -- ${sta.status.toUpperCase().padEnd(7, ' ')} -- ${sta.iterations}\n`
        }
      }
    })

    // check for component warnings that trigger FE events
    for (const val of Object.values(logStream.value.statuslog)) {
      if ("warning" in val && val.warning.startsWith("USER_STORAGE_QUOTA 80% WARNING")) {
        getUserStorage();
      }
    }
  }
}

const getPause = async () => {
  console.log("PAUSED orch");
  await fetch(userAPIEndPoint + "/pause", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` }
  }).then(Shared.methods.handleErrors)
    .then((response) => {
      if (response.ok) {
        startPending.value = false;
        pausePending.value = true;
        stopPending.value = false;

        startisDisabled.value = true;
        pauseisDisabled.value = true;
        stopisDisabled.value = true;
        return response.json();
      }
    }).then((data) => {
      console.log(data);
    });
};

const getStop = async () => {
  console.log("STOP orch");
  await fetch(userAPIEndPoint + "/stop", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` }
  }).then(Shared.methods.handleErrors)
    .then((response) => {
      if (response.ok) {
        startPending.value = false;
        pausePending.value = false;
        stopPending.value = true;

        startisDisabled.value = true;
        pauseisDisabled.value = true;
        stopisDisabled.value = true;
        return response.json();
      }
    }).then((data) => {
      console.log(data);
    });
  if (logStreamStopped.value == true) call_log_stream(); // when paused
};

const getUserAppTokens = async () => {
  console.log("getUserAppTokens");
  await fetch(authAPIEndPoint + "/get_user_app_tokens", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` }
  }).then(Shared.methods.handleErrors)
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
    }).then((data) => userAppTokens.value = data["user_app_tokens"])
}

const setUserAppTokens = async () => {
  console.log("setUserAppTokens");
  await fetch(authAPIEndPoint + "/set_user_app_tokens", {
    method: "POST",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` },
    body: JSON.stringify({ user_app_tokens: userAppTokens.value }, null, 2),
  }).then(Shared.methods.handleErrors)
}

watch(
  () => [props.viewlog, props.moreOptions],
  async (newval, oldval) => {
    viewRunLog.value = props.viewlog;
    moreOptions.value = props.moreOptions;
    if (viewRunLog.value) {
      await getStatus()
      console.log("Updated the run log from BE.")
    }
  }
);

watch(
  () => [props.runName],
  async (newval, oldval) => {
    runName.value = props.runName
  }
)

const getStatus = async () => {
  console.log("STATUS orch");
  await fetch(userAPIEndPoint + "/status", {
    method: "GET",
    headers: { "Authorization": `Bearer ${userJWTToken.value}` }
  }).then(Shared.methods.handleErrors)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
    }).then((data) => {
      runLog.value = JSON.stringify({ "time": data.time, "status": data.status }, null, "  ")
    });
};

__expose({
  logToObject,
  call_be_api_upload
});


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode(_toDisplayString(runName.value) + " ", 1),
        _hoisted_2,
        _createElementVNode("em", _hoisted_3, _toDisplayString(_ctx.$t('message.Last_saved')) + " " + _toDisplayString(lastSaved.value), 1)
      ]),
      _createElementVNode("button", {
        class: "orch-control",
        onClick: getStart,
        disabled: startisDisabled.value,
        style: {"float":"none"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "play",
          size: "lg",
          class: _normalizeClass({'fa-fade': startPending.value})
        }, null, 8, ["class"])
      ], 8, _hoisted_4),
      _createElementVNode("button", {
        class: "orch-control",
        onClick: getPause,
        disabled: pauseisDisabled.value,
        style: {"float":"none"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "pause",
          size: "lg",
          class: _normalizeClass({'fa-fade': pausePending.value})
        }, null, 8, ["class"])
      ], 8, _hoisted_5),
      _createElementVNode("button", {
        class: "orch-control",
        onClick: getStop,
        disabled: stopisDisabled.value,
        style: {"float":"none"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "stop",
          size: "lg",
          class: _normalizeClass({'fa-fade': stopPending.value})
        }, null, 8, ["class"])
      ], 8, _hoisted_6)
    ]),
    (mountNode.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "nodeDialogue",
          onClose: confirmComponent,
          title: "Component props",
          eleprops: currentElement.value,
          visibility: nodeVisibility.value
        }, {
          default: _withCtx(() => [
            _createVNode(NodeForm, {
              ref_key: "nodeFormTemplate",
              ref: nodeFormTemplate,
              "ele-props": currentElement.value,
              "all-comp-names": allCompNames.value,
              "workflow-settings": [startIsSet.value, endIsSet.value, driverIsSet.value],
              "has-connections": [hasIncomingConnections.value, hasOutgoingConnections.value],
              "flow-is-locked": flowIslocked.value,
              visibility: nodeVisibility.value,
              "run-name": runName.value,
              "log-stream": logStream.value,
              onDeleteParamfiles: deleteMultipleFiles,
              onUpdateComp: updateComp,
              onDeleteComp: deleteComp,
              onNodeMounted: onNodeFormMounted,
              onNodeBeforeUnmounted: onNodeFormUnMounted,
              onReportSave: nodeFormReportSave,
              onGetUserStorage: getUserStorage
            }, null, 8, ["ele-props", "all-comp-names", "workflow-settings", "has-connections", "flow-is-locked", "visibility", "run-name", "log-stream"])
          ]),
          _: 1
        }, 8, ["eleprops", "visibility"]))
      : _createCommentVNode("", true),
    (mountEdge.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "edgeDialogue",
          onClose: confirmComponent,
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createVNode(ConnectionForm, {
              "ele-props": currentConnection.value,
              "flow-is-locked": flowIslocked.value,
              onUpdateConnection: updateConnection,
              onDeleteConnection: deleteConnection
            }, null, 8, ["ele-props", "flow-is-locked"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (viewRunLog.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "runLog",
          onClose: confirmComponent,
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("textarea", {
                id: "component-log",
                cols: "70",
                rows: "35",
                readonly: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((runLog).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  runLog.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", { id: "basedialogbuttons" }, [
                _createElementVNode("button", {
                  class: "basedialog",
                  onClick: confirmComponent
                }, " Close ")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (moreOptions.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "moreOptions",
          onClose: confirmComponent,
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('message.Settings')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "basedialog",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {onBoardingMsg.value = true;})
              }, _toDisplayString(_ctx.$t('message.Welcome')), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('message.View_the_welcome_message')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "basedialog",
                onClick: _cache[2] || (_cache[2] = async () => {await getUserAppTokens(); userSecrets.value = true})
              }, _toDisplayString(_ctx.$t('message.User_secrets')), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('message.Secrets_are_a_secure_way')), 1)
            ]),
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('message.Run_Management')), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "basedialog",
                onClick: userStatsDisplay
              }, _toDisplayString(_ctx.$t('message.User_stats')), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('message.View_resource_usage_for_your_workspace')) + " ", 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('message.Share_Run')), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('message.Invite_another_user_to_view')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "basedialog dangerzone",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('resetRun')))
              }, _toDisplayString(_ctx.$t('message.Terminate')), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('message.Reset_your_run_environment')), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (onBoardingMsg.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "onBoardingMsg",
          onClose: _cache[6] || (_cache[6] = (e) => confirmComponent(true)),
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t('message.Welcome')), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('message.This_is_your_dashboard')) + " ", 1),
                _hoisted_22,
                _hoisted_23,
                _createTextVNode(),
                _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.Here_are_some_tips')), 1)
              ]),
              _createElementVNode("ul", _hoisted_24, [
                _createElementVNode("li", _hoisted_25, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "arrow-pointer",
                    color: "rgb(57, 57, 57)",
                    size: "2x",
                    transform: "shrink-8",
                    mask: "circle",
                    style: {"margin-right":"10px"}
                  }),
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.Learn')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.about_the')) + " ", 1),
                  _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.$t('message.dashboard_controls')), 1),
                  _createTextVNode(".")
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "lightbulb",
                    color: "rgb(57, 57, 57)",
                    size: "2x",
                    transform: "shrink-8",
                    mask: "circle",
                    style: {"margin-right":"10px"}
                  }),
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.Learn')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.how_to_create')) + " ", 1),
                  _createElementVNode("a", _hoisted_28, _toDisplayString(_ctx.$t('message.Intro_Tutorial')), 1)
                ]),
                _createElementVNode("li", _hoisted_29, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "book",
                    color: "rgb(57, 57, 57)",
                    size: "2x",
                    transform: "shrink-8",
                    mask: "circle",
                    style: {"margin-right":"10px"}
                  }),
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.View')), 1),
                  _createTextVNode(),
                  _createElementVNode("a", _hoisted_30, _toDisplayString(_ctx.$t('message.User_Guide')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.by_clicking_on_the_help')) + " ", 1),
                  _hoisted_31,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.button_at_any_time')), 1)
                ]),
                _createElementVNode("li", _hoisted_32, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "comment-dots",
                    color: "rgb(57, 57, 57)",
                    size: "2x",
                    transform: "shrink-8",
                    mask: "circle",
                    style: {"margin-right":"10px"}
                  }),
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.Chat')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.to_our_expert')) + " ", 1),
                  _hoisted_33
                ])
              ]),
              _hoisted_34,
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.Happy_simulating')), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "basedialog",
                onClick: confirmComponent
              }, _toDisplayString(_ctx.$t('message.Close')), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hideOnBoardingMsg).value = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (check($event)))
                }, null, 544), [
                  [_vModelCheckbox, hideOnBoardingMsg.value]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.show_this_message')), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (userSecrets.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "userSecrets",
          onClose: _cache[11] || (_cache[11] = (e) => confirmComponent()),
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.$t('message.User_secrets')), 1),
            _createElementVNode("ul", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userAppTokens.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", {
                    class: "secret-listicon",
                    onClick: ($event: any) => (deleteSecretItem(index))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "minus-circle",
                      size: "lg"
                    })
                  ], 8, _hoisted_39),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass({ invalid: /^[a-zA-Z0-9]([-a-zA-Z0-9]*[a-zA-Z0-9])?$/.test(item.name) == false}),
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                      placeholder: _ctx.$t('message.NAME'),
                      required: "",
                      onBlur: _cache[7] || (_cache[7] = ($event: any) => (getUserAppTokensValidity()))
                    }, null, 42, _hoisted_41), [
                      [
                        _vModelText,
                        item.name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass({ invalid: /^[a-zA-Z0-9]([-a-zA-Z0-9]*[a-zA-Z0-9])?$/.test(item.value) == false}),
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                      placeholder: _ctx.$t('message.VALUE'),
                      required: "",
                      onBlur: _cache[8] || (_cache[8] = ($event: any) => (getUserAppTokensValidity()))
                    }, null, 42, _hoisted_44), [
                      [
                        _vModelText,
                        item.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "secret-listicon",
                  onClick: addSecretItem
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "plus-circle",
                    size: "lg"
                  })
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: _ctx.$t('message.NAME'),
                    readonly: "true",
                    style: {"background-color":"#ccc"}
                  }, null, 8, _hoisted_46)
                ]),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: _ctx.$t('message.VALUE'),
                    readonly: "true",
                    style: {"background-color":"#ccc"}
                  }, null, 8, _hoisted_49)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                class: "basedialog",
                onClick: _cache[9] || (_cache[9] = async() => {await setUserAppTokens(); userAppTokensValid.value = false}),
                disabled:  userAppTokensValid.value == false && userAppTokens.value.length>0
              }, _toDisplayString(_ctx.$t('message.Save')), 9, _hoisted_51),
              _createElementVNode("button", {
                class: "basedialog",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmComponent()))
              }, _toDisplayString(_ctx.$t('message.Close')), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (contextOpen.value)
      ? (_openBlock(), _createBlock(ContextMenu, {
          key: 6,
          style: _normalizeStyle(atMousePos.value)
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", {
              class: "contextoption",
              onClick: AddEmptyNode
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.Add_Empty_Node')), 1)
            ])
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueFlow), {
      modelValue: elements.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((elements).value = $event)),
      class: "vue-flow",
      "node-types": ['selectorNode'],
      "edge-types": ['customline'],
      "connection-mode": _unref(ConnectionMode).Loose,
      "snap-to-grid": true,
      "snap-grid": snapGrid,
      "default-zoom": 1.0,
      onElementClick: onElementClick,
      onElementsRemove: onElementsRemove,
      onConnect: onConnect,
      onNodeDragStop: onNodeDragStop,
      onLoad: onLoad,
      onContextmenu: _withModifiers(onRightClick, ["prevent"])
    }, {
      "node-selectorNode": _withCtx((props) => [
        _createVNode(EditableNode, _mergeProps({ class: "node-template" }, props, { onUpdateHandles: updateHandles }), null, 16)
      ]),
      "edge-customline": _withCtx((props) => [
        _createVNode(ConnectionLine, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Controls), { showInteractive: false }),
        _createVNode(_unref(Background), {
          variant: "dots",
          gap: 20,
          size: 0.5,
          color: 'rgb(0, 70, 201)'
        }, null, 8, ["color"])
      ]),
      _: 1
    }, 8, ["modelValue", "connection-mode", "onContextmenu"])
  ], 64))
}
}

})